jQuery(document).ready(function (jQuery) {

  const settings = {
    //Model Popup
    objModalPopupBtn: ".modalButton",
    objModalCloseBtn: ".overlay, .closeBtn",
    objModalDataAttr: "data-popup",
  };
  $(document).on("click", settings.objModalPopupBtn, function () {
    if ($(this).attr(settings.objModalDataAttr)) {
      event.preventDefault();
      if ($(this).hasClass("disabled")) {
        return;
      }
      var strDataPopupName = $(this).attr(settings.objModalDataAttr);

      if (strDataPopupName == "individuell_modal") {
        setTimeout(function () {
          $(".individuell-nummer-text").focus();
        }, 500);
      }

      //Fade In Modal Pop Up
      $("#" + strDataPopupName).fadeIn();
      $("#" + strDataPopupName)
        .next(".overlay")
        .fadeIn();
      $("body").addClass("overflow-hidden open-popup");

      let closestProductInfo = $(this).closest("product-info");
      let product_form__error_message_wrapper = $(closestProductInfo).find(
        ".product-form__error-message-wrapper"
      );
      let product_form__error_message = $(closestProductInfo).find(
        ".product-form__error-message"
      );
      product_form__error_message_wrapper.attr("hidden", true);
      product_form__error_message.text("");
    }
  });

  //On clicking the modal background
  $(document).on("click", settings.objModalCloseBtn, function () {
    $(".modal").fadeOut();
    $("body").removeClass("overflow-hidden open-popup");
  });

   // Dropdown toggle logic
  $(".toggle-dropdown-wrap").click(function () {
    console.log('toggle-dropdown-wrap');
    $(this).toggleClass("opened");
  });

  document.addEventListener("click", (e) => {
    // console.log('element',e);
    document
      .querySelectorAll(".toggle-dropdown-wrap.opened")
      .forEach((dropdown) => {
        if (!dropdown.contains(e.target)) {
          dropdown.classList.remove("open", "opened");
        }
      });
  });  

  // single new in related new show as per contetn height js start
  // Function to adjust news section heights
  function newssectionHeights() {
    if ($(window).width() > 1000) {
      /*const newsContent = $('.grapesContentBuilder_wrap .gjs-row .gjs-cell').length
                          ? $('.grapesContentBuilder_wrap .gjs-row .gjs-cell').first()
                          : $(".news-content-wrapper .blog_wrapper");*/

      if($(".news-content-wrapper .blog_wrapper").length == 0){
        return false;
      }
      const newsContent = $(".news-content-wrapper .blog_wrapper");

      const relatedNewsCol = $(".news-content-wrapper .related-news").find(
        ".content-container"
      );


      // Get element heights
      const newsContentHeight = newsContent.outerHeight();
      const relatedNewsColHeight = relatedNewsCol.outerHeight();
      const relatedNewsColLength = relatedNewsCol.length;

      // Hide all content containers initially
      relatedNewsCol.hide();

      // Calculate how many containers should be shown
      const numToShow = Math.floor(newsContentHeight / relatedNewsColHeight);

      // Show the required number of content containers
      relatedNewsCol.slice(0, numToShow).show();
    } else {
      // If window width is less than or equal to 1000, show all content containers
      $(".news-content-wrapper .related-news .content-container").show();
    }
  }

  // Initial call
  newssectionHeights();

  // Run function after a delay (1000ms)
  $(window).on("load", () => {
    setTimeout(() => {
      newssectionHeights();
    }, 1000);
  });
  // Add debounce for resize events
  let resizeNewssection;
  $(window).on("resize", () => {
    clearTimeout(resizeNewssection);
    resizeNewssection = setTimeout(() => {
      newssectionHeights();
    }, 500); // Adjust delay time as needed
  });

  // Run the function after AJAX call is completed
  $(document).ajaxComplete(() => {
    newssectionHeights();
  });
  // single new in related new show as per contetn height js end

  $(document).on("click", ".data-table-items.row", function () {
    $(this).toggleClass("opened"); //Adds 'a', removes 'b' and vice versa
  });
});

function updateHeights() {
  if (document.querySelector(".aico-address-teaser-text-block")) {
    setMaxHeight(
      ".aico-address-teaser-text-block",
      ".aico-title",
      "--title-max-height"
    );
  }

  if (document.querySelector(".aico-tile-content-wrapper .aico-tile-block-wrapper")) {
    setMaxHeight(
      ".aico-tile-content-wrapper .aico-tile-block-wrapper",
      ".aico-tile-subtitle",
      "--subtitle-max-height"
    );
  }
}

// Debounce function to limit rapid firing on resize
let resizeTimeout;
$(window).on("resize", () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    updateHeights();
  }, 100);
});

$(document).ready(() => {
  updateHeights();

  $(document).on("click", ".cookie-button", function () {
    event.preventDefault();
    UC_UI.showSecondLayer();
  });
});